module.exports = __webpack_public_path__ + "img/03_active.a2387639.png";